module.exports = __webpack_public_path__ + "img/ae87062.svg";